import { Pipe, PipeTransform } from '@angular/core';

import { I18nService, I18nTranslateOptions } from './i18n.service';

@Pipe({
  standalone: true,
  name: 'translate',
})
export class TranslatePipe implements PipeTransform {
  constructor(private i18nService: I18nService) {}

  public transform(key: string, options: I18nTranslateOptions | any = {}): string {
    return this.i18nService.translate(key, options);
  }
}
